import { render, staticRenderFns } from "./DvDecoration.vue?vue&type=template&id=21862642"
import script from "./DvDecoration.vue?vue&type=script&lang=js"
export * from "./DvDecoration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports